import type { Addon, BillingPlan, KiwiAddon, PaymentInterval, Price } from '@core/billing-types';
import { AddonType } from '@core/billing-types';

export function getProductCost(
  product: BillingPlan,
  slots: number,
  interval: PaymentInterval,
  addons: Addon[],
  price?: Price,
): number;

export function getProductCost(
  product: any,
  slots: number,
  interval: PaymentInterval,
  addons: Addon[],
  price?: Price,
): number {
  const addedSlotsCount = slots - product.baseSlots;
  const textingAddon = addons?.find(addon => addon.type === AddonType.Texting);
  const textingAddonQuantity = textingAddon ? textingAddon.quantity : 0;

  const kiwiAddon = <KiwiAddon>addons?.find(addon => addon.type === AddonType.Kiwi);
  const kiwiAddonQuantity = kiwiAddon ? kiwiAddon.quantity : 0;

  const intervalInt = parseInt(`${interval}`, 10);
  const parsedInterval = !isNaN(intervalInt) ? intervalInt : interval;

  switch (typeof parsedInterval) {
    case 'number':
      if (['start', 'grow', 'optimize'].includes(product?.tier)) {
        throw new Error('For new plans, use get2024ProductCosts');
      }

      const { basePrice, slotPrice, textingPrice, kiwihrPlusPrice } =
        product.pricing[parsedInterval];

      const slotsPrice = slotPrice * addedSlotsCount;
      const textingAddonPrice = textingAddonQuantity * textingPrice;
      const kiwiAddonPrice = kiwiAddonQuantity * kiwihrPlusPrice;
      const totalPrice = slotsPrice + basePrice + textingAddonPrice + kiwiAddonPrice;
      return totalPrice / 100;

    case 'string':
      switch (parsedInterval) {
        case 'month':
          return (
            (addedSlotsCount * product.monthlySlotAmount +
              product.monthlyBaseAmount +
              product.pricing[1].textingPrice * textingAddonQuantity +
              product.pricing[1].kiwihrPlusPrice * kiwiAddonQuantity) /
            100
          );

        case 'year':
          return (
            (addedSlotsCount * product.yearlySlotAmount +
              product.yearlyBaseAmount +
              product.pricing[12].textingPrice * textingAddonQuantity +
              product.pricing[12].kiwihrPlusPrice * kiwiAddonQuantity) /
            100
          );

        default:
          throw new Error(`Unknown interval ${interval}`);
      }
    default:
      throw new Error(`Unknown interval ${interval}`);
  }
}
